import { Copy, Flex } from '@grubhubprod/gh-cookbook-react';
import React from 'react';

export interface IChildAccountTableCounter {
  currentNumberOfAccounts: number;
  maximumAllowedAccounts: number;
}

export function ChildAccountTableCounter({
  currentNumberOfAccounts,
  maximumAllowedAccounts,
}: IChildAccountTableCounter): JSX.Element {
  return (
    <Flex justifyContent="flex-end" role="status">
      <Copy
        variant="caption"
        color="secondaryText"
      >{`${currentNumberOfAccounts} / ${maximumAllowedAccounts}`}</Copy>
    </Flex>
  );
}
